import JSZip from "jszip";
import type { InstaUser } from "@/insta/types/instaTypes";

interface InstaRawEntry {
  string_list_data: { value: string; href: string; timestamp: number }[];
}

interface FollowingJson {
  relationships_following: InstaRawEntry[];
}

function parseUsers(entries: InstaRawEntry[]): InstaUser[] {
  return entries.map((item) => {
    const user = item.string_list_data[0];
    return {
      value: user.value,
      href: user.href,
      timestamp: user.timestamp,
    };
  });
}

export async function processZipFile(
  file: File
): Promise<{ followers: InstaUser[]; following: InstaUser[] }> {
  const zip = await JSZip.loadAsync(file);

  // Find followers files (followers_1.json, followers_2.json, ...)
  const followerFiles: string[] = [];
  let followingFile: string | null = null;

  zip.forEach((relativePath) => {
    const lower = relativePath.toLowerCase();
    if (
      lower.includes("followers_and_following/") ||
      lower.includes("followers_and_following\\")
    ) {
      if (/followers_\d+\.json$/i.test(relativePath)) {
        followerFiles.push(relativePath);
      } else if (/following\.json$/i.test(relativePath)) {
        followingFile = relativePath;
      }
    }
  });

  if (followerFiles.length === 0) {
    throw new Error(
      "ZIP 파일에서 followers 파일을 찾을 수 없습니다. followers_and_following 폴더가 포함된 ZIP 파일을 업로드해주세요."
    );
  }

  if (!followingFile) {
    throw new Error(
      "ZIP 파일에서 following.json 파일을 찾을 수 없습니다. followers_and_following 폴더가 포함된 ZIP 파일을 업로드해주세요."
    );
  }

  // Parse all follower files and merge
  const allFollowers: InstaUser[] = [];
  followerFiles.sort();

  for (const path of followerFiles) {
    const content = await zip.file(path)!.async("string");
    const data: InstaRawEntry[] = JSON.parse(content);
    allFollowers.push(...parseUsers(data));
  }

  // Parse following file
  const followingContent = await zip.file(followingFile)!.async("string");
  const followingData: FollowingJson = JSON.parse(followingContent);
  const following = parseUsers(followingData.relationships_following);

  return { followers: allFollowers, following };
}
